module.exports = __webpack_public_path__ + "img/mapa_fr.a683bf21.jpg";